import { useEffect, useState } from "react";

const useStorage = (type: "session" | "local", key: string) => {
  const [value, setValue] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const handleSetValue = (data: string) => {
    if (type === "session") {
      sessionStorage.setItem(key, data);
    }

    if (type === "local") {
      localStorage.setItem(key, data);
    }
  }

  useEffect(() => {
    if (type === "session") {
      setValue(sessionStorage.getItem(key));
      setIsLoading(false);
    }

    if (type === "local") {
      setValue(localStorage.getItem(key));
      setIsLoading(false);
    }
  }, []);


  return [value, handleSetValue, isLoading] as [string, (data: string) => void, boolean];
}

export default useStorage;
